import React from 'react';
import { Skeleton, Stack } from '@mui/material';
import { useChartHeight } from './chartUtils';

export function ChartSkeleton() {
    const chartHeight = useChartHeight();

    return (
        <Stack height={ chartHeight }>
            <Skeleton
                variant='rectangular'
                height={ '100%' }
                sx={ {
                    borderRadius: 0.5
                } } />
            <Skeleton
                sx={ {
                    fontSize: 24,
                    mt: 1
                } } />
        </Stack>
    );
}
